export default __webpack_public_path__ + "static/media/w95fa.fb426abf.woff2";